// extracted by mini-css-extract-plugin
export var boxItems = "_8j-1";
export var boxItemsLg = "_8j-2";
export var button = "_8j-7";
export var buttonHoverless = "_8j-9";
export var buttonLg = "_8j-8";
export var filterGroupBox = "_8j-0";
export var icon = "_8j-3";
export var iconSecondary = "_8j-6";
export var iconWrapper = "_8j-4";
export var iconWrapperLg = "_8j-5";
export var truncatedLabel = "_8j-a";